import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';
import { compact } from 'lodash';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { buildVehicleDataPath, VehicleEditorialModel } from 'client/data/models/vehicle-editorial';
import { buildMakeModelInventoryCountPath, InventoryAggregateModel } from 'client/data/models/inventory-aggregate';
import { buildMakeModelDefaultYear, VehicleDefaultModel } from 'client/data/models/vehicle-v2-default';
import { makeNiceName } from 'site-modules/shared/utils/nice-name';
import { generateNewFlatUrl } from 'site-modules/shared/utils/srp-link-constructor';
import { Link } from 'site-modules/shared/components/link/link';
import { getPlural } from 'client/utils/plural';

function ArticleSrpLinkUI({
  className,
  contentVehicle: { make, model },
  defaultYear,
  pubStates,
  isMobile,
  inventoryCount,
}) {
  const isNew = pubStates?.some(pubState => ['NEW', 'NEW_USED'].includes(pubState));
  if (!isNew) {
    return null;
  }

  return (
    <div className={classnames('article-srp-link', className)} data-tracking-parent="article_srp_link">
      {!!inventoryCount && (
        <div className="heading-5 mb-0_75">
          See {inventoryCount} {compact([defaultYear, make, model]).join(' ')} {getPlural('vehicle', inventoryCount)}{' '}
          for sale near you
        </div>
      )}
      <Button
        color="primary-b"
        size="lg"
        className={classnames('py-0_5 px-1 text-transform-none text-decoration-none text-white px-md-2 fw-normal', {
          'w-100': isMobile,
        })}
        style={{ whiteSpace: 'normal' }}
        tag={Link}
        to={generateNewFlatUrl({
          make: makeNiceName(make),
          model: makeNiceName(model),
        })}
        data-tracking-parent="article_srp_link"
        data-tracking-id="srp_link"
      >
        See All for Sale
      </Button>
    </div>
  );
}

ArticleSrpLinkUI.propTypes = {
  contentVehicle: PropTypes.shape({
    make: PropTypes.string,
    model: PropTypes.string,
    year: PropTypes.string,
  }),
  pubStates: PropTypes.arrayOf(PropTypes.string),
  defaultYear: PropTypes.number,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
  inventoryCount: PropTypes.number,
};

ArticleSrpLinkUI.defaultProps = {
  contentVehicle: null,
  pubStates: null,
  defaultYear: null,
  className: null,
  isMobile: false,
  inventoryCount: null,
};

export const ArticleSrpLink = connectToModel(ArticleSrpLinkUI, {
  pubStates: bindToPath(
    ({ contentVehicle: { make, model, year } }) =>
      buildVehicleDataPath({ make: makeNiceName(make), model: makeNiceName(model), year }),
    VehicleEditorialModel,
    ({ publicationStates }) => publicationStates
  ),
  inventoryCount: bindToPath(
    ({ contentVehicle: { make, model } }) =>
      buildMakeModelInventoryCountPath({ make: makeNiceName(make), model: makeNiceName(model), radius: 100 }),
    InventoryAggregateModel
  ),
  defaultYear: bindToPath(
    ({ contentVehicle: { make, model } }) =>
      buildMakeModelDefaultYear({ make: makeNiceName(make), model: makeNiceName(model) }),
    VehicleDefaultModel
  ),
});
